import axios, { AxiosRequestConfig } from "axios"
import { getApiUrl } from "backend-routes"
import { HttpVerb } from "etl/types"

export const etlAxiosInstance = axios.create({
	baseURL: getApiUrl().etlUrl,
	headers: {
		"Content-Type": "application/ld+json",
	},
})

export interface AxiosParams {
	url: string
	method: AxiosRequestConfig["method"]
	data?: AxiosRequestConfig["data"]
	params?: AxiosRequestConfig["params"]
	headers?: AxiosRequestConfig["headers"]
	responseType?: AxiosRequestConfig["responseType"]
}

export const etlAxiosBaseQuery = async ({ url, method, data, params, headers, responseType }: AxiosParams) => {

	if (method === HttpVerb.PATCH) {
		headers = {
			...headers,
			"Content-Type": "application/merge-patch+json",
		}
	}

	return await etlAxiosInstance({
		url,
		method,
		data,
		params,
		headers,
		responseType,
	})
}
